import { useNavigate } from "react-router-dom";
import React from "react";
import styles from "../../assets/styles/AppHome/QuickLinksCard.module.scss";
import { QuickLinksComponent as QLC } from "../../components/Home";
import constant from "../../utils/constant";
import { businessStore } from "../../stores";
import DashboardLinkCopy from "./DashboardLinkCopy";

const QuickLinksCard = ({ goToMeasurement }) => {
  const navigate = useNavigate();

  const websiteLink = businessStore.business.storeFrontUrl;

  return (
    <div className={styles.ql}>
      <DashboardLinkCopy link={websiteLink} title="Your Website Link:" />
      <h4 className={styles.ql__title}>Quick Links</h4>
      <nav className={styles.ql__content}>
        <QLC
          title="Upload Style"
          onClick={() => navigate(constant.Routes.Styles)}
        />
        <QLC
          title="Add Customer"
          onClick={() => navigate(constant.Routes.Customer)}
        />
        <QLC
          title="Configure Website"
          onClick={() => navigate(constant.Routes.WebsiteConfig)}
        />

        <QLC title="Orders" onClick={() => navigate(constant.Routes.Orders)} />

        <QLC title="Measurement" onClick={goToMeasurement} />
        <QLC
          title="Payment Link"
          onClick={() => navigate(constant.Routes.PaymentLink)}
        />
        <QLC
          title="Transactions"
          onClick={() => navigate(constant.Routes.Transactions)}
        />
      </nav>
    </div>
  );
};

export default QuickLinksCard;
